"use client";

import { useEffect, useState } from "react";
import { Form, Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import "./Wallet.css";

import Green_btn from "../../../common-components/common_btn/green_btn/Green_btn";

import {
  getAllWalletHistory,
  postAddMoney,
  postWithdrawRequest,
} from "../../../../features/wallet/walletSlice";
import AddMoneyForm from "./add_money_form/AddMoneyForm";
import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import useRazorpay from "react-razorpay";
function Wallet() {
  const [key, setKey] = useState("wallet");

  const [showAddModal, setShowAddModal] = useState(false);
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);

  const [showModal, setShowModal] = useState(false);

  const [modalData, setModalData] = useState({
    title: "",
    subText: "",
  });

  const openModal = (title, subText) => {
    setModalData({
      title,
      subText,
    });

    setShowModal(true);
  };
  const handleOpenModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const dispatch = useDispatch();

  const allWalletHistory = useSelector(
    (state) => state.wallet.allWalletHistory,
  );

  useEffect(() => {
    dispatch(getAllWalletHistory());
  }, [dispatch]);

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);

    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const [selectedAmount, setSelectedAmount] = useState(1000);
  const [showPaymentScreen, setShowPaymentScreen] = useState(false);

  const {
    register: addRegister,
    handleSubmit: addHandleSubmit,
    setValue,
    watch,
    formState: { errors: addErrors },
    reset: addReset,
  } = useForm();
  const amount = watch("amount");

  const {
    register: withdrawRegister,
    handleSubmit: withdrawHandleSubmit,
    formState: { errors: withdrawErrors },
    reset: withdrawReset,
  } = useForm();

  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const onSubmit = async (data) => {
    try {
      const payload = {
        amount: data.withdraw_amount,
        ifsc_code: data.ifsc_code,
        account_no: data.account_no,
        branch_name: data.branch_name,
        banking_name: data.banking_name,
      };

      const res = await dispatch(postWithdrawRequest({ data: payload }));

      if (res.meta?.requestStatus === "fulfilled") {
        openModal(
          "Withdraw Request Submitted!",
          "Your money will be credited within 24 hours.",
        );
        withdrawReset();
        await dispatch(getAllWalletHistory());
      } else {
        openModal(
          "Withdraw Failed!",
          res?.payload?.errors || "Unable to process withdraw request.",
        );
      }
      setTimeout(() => {
        setShowModal(false);
      }, 2000);
    } catch (error) {
      console.log(error);

      openModal("Something Went Wrong!", "Unable to process withdraw request.");
      setTimeout(() => {
        setShowModal(false);
      }, 2000);
    }
  };

  const currentBalance = parseFloat(
    allWalletHistory?.user_wallet?.amount,
  ).toFixed(2);

  const [razorid, setRazorId] = useState();
  const finalFunction = async (d, transactionId) => {
    try {
      const data = {
        transaction_id: transactionId,
        amount: d.amount,
        transaction_type: "credit",
      };

      const res = await dispatch(postAddMoney({ data }));

      if (res.meta?.requestStatus === "fulfilled") {
        openModal(
          "Amount Added Successfully!",
          "Wallet amount added successfully.",
        );
        addReset();
        await dispatch(getAllWalletHistory());
      } else {
        openModal(
          "Payment Failed!",
          res?.payload?.errors || "Unable to add money to wallet.",
        );
      }
      setTimeout(() => {
        setShowModal(false);
      }, 2000);
    } catch (error) {
      console.log(error);
      openModal("Something Went Wrong!", "Unable to process payment.");
    }
  };

  const Razorpay = useRazorpay();

  const handleRazorpay = async (data) => {
    try {
      if (!window.Razorpay) {
        openModal("Razorpay Error!", "Razorpay SDK failed to load.");
        setTimeout(() => {
          setShowModal(false);
        }, 2000);

        return;
      }

      const amountInPaise = Number(data.amount) * 100;

      const options = {
        key: "rzp_test_I05KCFb1v5JJRc",
        amount: amountInPaise,
        currency: "INR",
        name: "RED LOTTUS",
        description: "Wallet Recharge",
        handler: async function(response) {
          await finalFunction(data, response.razorpay_payment_id);
        },
        modal: {
          ondismiss: function() {
            openModal(
              "Payment Cancelled!",
              "You cancelled the payment process.",
            );
            setTimeout(() => {
              setShowModal(false);
            }, 2000);
          },
        },
        prefill: {
          name: "User",
          email: "test@gmail.com",
          contact: "9999999999",
        },

        theme: {
          color: "#052c65",
        },
      };

      const paymentObject = new window.Razorpay(options);

      paymentObject.open();
    } catch (error) {
      console.log(error);

      openModal("Payment Failed!", "Unable to initiate payment.");
      setTimeout(() => {
        setShowModal(false);
      }, 2000);
    }
  };

  return (
    <>
      <div className="container conatiner-section">
        <div className="wallet_container ">
          <Tabs
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="wallet_tabs mb-4"
          >
            <Tab
              eventKey="wallet"
              title="Add Money"
              className="content-wrapper"
            >
              <>
                {/* {!showPaymentScreen ? ( */}
                <div className="tab_content box  col-12 col-lg-10 mx-auto">
                  <div className="wallet_header">
                    <div className="wrapper-div ">
                      <div className="balance_amount">
                        ₹
                        {parseFloat(
                          allWalletHistory?.user_wallet?.amount || 0,
                        ).toFixed(2)}
                      </div>

                      <div className="balance_label">Available Balance</div>
                    </div>
                    <div className="img-holder">
                      <img src="/assets/images/icon/wallet.png" alt="not" />
                    </div>
                  </div>

                  <div className="add_money_section">
                    <h4 className="wallet_section_title">
                      Add Money to Wallet
                    </h4>
                    <div className="amount_input_wrapper">
                      <div className="rupee_icon">₹</div>

                      <Form.Control
                        type="number"
                        min={1}
                        placeholder="Enter Amount"
                        className="wallet_amount_input"
                        {...addRegister("amount", {
                          required: "Amount is required",
                          min: {
                            value: 1,
                            message: "Minimum amount should be 1",
                          },
                        })}
                      />
                    </div>

                    {addErrors.amount && (
                      <p className="text-danger mt-1">
                        {addErrors.amount.message}
                      </p>
                    )}

                    <div className="quick_amount_wrapper">
                      <button
                        type="button"
                        className={
                          Number(amount) === 500
                            ? "amount_btn active"
                            : "amount_btn"
                        }
                        onClick={() =>
                          setValue("amount", 500, {
                            shouldValidate: true,
                            shouldDirty: true,
                          })
                        }
                      >
                        ₹ 500
                      </button>

                      <button
                        type="button"
                        className={
                          Number(amount) === 1000
                            ? "amount_btn active"
                            : "amount_btn"
                        }
                        onClick={() =>
                          setValue("amount", 1000, {
                            shouldValidate: true,
                            shouldDirty: true,
                          })
                        }
                      >
                        ₹ 1000
                        <span className="popular_tag">Popular</span>
                      </button>
                    </div>

                    <div className="quick_amount_wrapper">
                      <button
                        type="button"
                        className={
                          Number(amount) === 2000
                            ? "amount_btn active"
                            : "amount_btn"
                        }
                        onClick={() =>
                          setValue("amount", 2000, {
                            shouldValidate: true,
                            shouldDirty: true,
                          })
                        }
                      >
                        ₹ 2000
                      </button>

                      <button
                        type="button"
                        className={
                          Number(amount) === 5000
                            ? "amount_btn active"
                            : "amount_btn"
                        }
                        onClick={() =>
                          setValue("amount", 5000, {
                            shouldValidate: true,
                            shouldDirty: true,
                          })
                        }
                      >
                        ₹ 5000
                      </button>
                    </div>

                    {/* <div className="quick_amount_wrapper">
                        <button
                          className={
                            selectedAmount === 500
                              ? "amount_btn active"
                              : "amount_btn"
                          }
                          onClick={() => setSelectedAmount(500)}
                        >
                          ₹ 500
                        </button>

                        <button
                          className={
                            selectedAmount === 1000
                              ? "amount_btn active"
                              : "amount_btn"
                          }
                          onClick={() => setSelectedAmount(1000)}
                        >
                          ₹ 1000
                          <span className="popular_tag">Popular</span>
                        </button>
                      </div>
                      <div className="quick_amount_wrapper">
                        <button
                          className={
                            selectedAmount === 2000
                              ? "amount_btn active"
                              : "amount_btn"
                          }
                          onClick={() => setSelectedAmount(2000)}
                        >
                          ₹ 2000
                        </button>

                        <button
                          className={
                            selectedAmount === 5000
                              ? "amount_btn active"
                              : "amount_btn"
                          }
                          onClick={() => setSelectedAmount(5000)}
                        >
                          ₹ 5000
                        </button>
                      </div>
                       */}
                    <div className="wallet_add_btn_wrapper gradient-btn">
                      <Green_btn
                        btnText="Add Money"
                        onClick={addHandleSubmit(handleRazorpay)}
                      />
                    </div>
                  </div>
                </div>
              </>
            </Tab>

            <Tab
              eventKey="actions"
              title="Withdraw Money"
              className="content-wrapper"
            >
              <div className="tab_content box  col-12 col-lg-10 mx-auto">
                <div className="wallet_header">
                  <div className="wrapper-div ">
                    <div className="balance_amount">
                      ₹
                      {parseFloat(
                        allWalletHistory?.user_wallet?.amount || 0,
                      ).toFixed(2)}
                    </div>

                    <div className="balance_label">Available Balance</div>
                  </div>
                  <div className="img-holder">
                    <img src="/assets/images/icon/wallet.png" alt="not" />
                  </div>
                </div>

                <div className="add_money_section">
                  {/* <h4 className="wallet_section_title">Withdraw Amount</h4>

                  <div className="amount_input_wrapper">
                    <div className="rupee_icon">₹</div>

                    <Form.Control
                      type="text"
                      placeholder="Enter Amount"
                      // value="500"
                      className="wallet_amount_input"
                    />
                  </div>
                  <h4 className="wallet_section_title">Enter UPI ID</h4>

                  <div className="amount_input_wrapper">
                    <div className="rupee_icon upi-img-wrapper">
                      <img src="/assets/images/payment/layer1.png" />
                    </div>

                    <Form.Control
                      type="text"
                      placeholder="Enter Upi Id"
                      className="wallet_amount_input"
                    />
                  </div> */}

                  <Form onSubmit={withdrawHandleSubmit(onSubmit)}>
                    {/* Amount */}
                    <div className="form-group input_group">
                      <Form.Label>Amount</Form.Label>
                      <Form.Control
                        type="number"
                        min={1}
                        step="1"
                        placeholder="Enter amount"
                        {...withdrawRegister("withdraw_amount", {
                          required:
                            Number(currentBalance) > 0
                              ? "Amount is required"
                              : "No balance available",

                          validate: (value) => {
                            const amount = Number(value);
                            const balance = Number(currentBalance);

                            if (!value) {
                              return "Amount is required";
                            }

                            if (!Number.isFinite(amount)) {
                              return "Please enter a valid amount";
                            }

                            if (amount <= 0) {
                              return "Amount must be greater than 0";
                            }

                            if (!Number.isInteger(amount)) {
                              return "Amount must be a whole number";
                            }

                            if (amount > balance) {
                              return `Amount must be less than or equal to ${balance}`;
                            }

                            return true;
                          },
                        })}
                        disabled={Number(currentBalance) === 0}
                      />

                      {/* Show custom error if balance is 0 */}
                      {Number(currentBalance) === 0 && (
                        <sup className="text-danger">
                          You have no balance available
                        </sup>
                      )}

                      {withdrawErrors.withdraw_amount && (
                        <p className="text-danger">
                          {withdrawErrors.withdraw_amount.message}
                        </p>
                      )}
                    </div>

                    {/* ifsc_code Code */}
                    <div className="form-group input_group">
                      <Form.Label>IFSC Code</Form.Label>

                      <Form.Control
                        type="text"
                        placeholder="Enter IFSC code"
                        {...withdrawRegister("ifsc_code", {
                          required: "IFSC Code is required",

                          pattern: {
                            value: /^[A-Z]{4}0[A-Z0-9]{6}$/,

                            message:
                              "Enter a valid IFSC code (e.g., HDFC0001234)",
                          },
                        })}
                      />

                      {withdrawErrors.ifsc_code && (
                        <p className="text-danger">
                          {withdrawErrors.ifsc_code.message}
                        </p>
                      )}
                    </div>
                    {/* Account No */}
                    <div className="form-group input_group">
                      <Form.Label>Account No</Form.Label>

                      <Form.Control
                        type="text"
                        placeholder="Enter account number"
                        {...withdrawRegister("account_no", {
                          required: "Account number is required",

                          pattern: {
                            value: /^[0-9]{9,18}$/,

                            message:
                              "Enter a valid account number (9 to 18 digits)",
                          },
                        })}
                      />

                      {withdrawErrors.account_no && (
                        <p className="text-danger">
                          {withdrawErrors.account_no.message}
                        </p>
                      )}
                    </div>

                    <div className="form-group input_group">
                      <Form.Label>Branch Name</Form.Label>

                      <Form.Control
                        type="text"
                        placeholder="Enter Branch Name"
                        {...withdrawRegister("branch_name", {
                          required: "Branch Name is required",
                        })}
                      />

                      {withdrawErrors.branch_name && (
                        <p className="text-danger">
                          {withdrawErrors.branch_name.message}
                        </p>
                      )}
                    </div>

                    <div className="form-group input_group">
                      <Form.Label>Banking Name</Form.Label>

                      <Form.Control
                        type="text"
                        placeholder="Enter Banking Name"
                        {...withdrawRegister("banking_name", {
                          required: "Banking Name is required",
                        })}
                      />

                      {withdrawErrors.banking_name && (
                        <p className="text-danger">
                          {withdrawErrors.banking_name.message}
                        </p>
                      )}
                    </div>
                    <div className="wallet_add_btn_wrapper">
                      <Green_btn btnText="Withdraw Money" type="submit" />
                    </div>
                  </Form>
                </div>
              </div>
            </Tab>

            {/* HISTORY TAB */}
            <Tab eventKey="history" title="Wallet Transaction">
              <div className="tab_content mx-auto">
                <div className="transaction_history_card">
                  <div className="Table_holder">
                    <div className="table-responsive">
                      <table className="transaction_table">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Description</th>

                            <th>Amount</th>
                            <th>Type</th>
                            <th>Transaction id</th>
                          </tr>
                        </thead>
                        <tbody>
                          {allWalletHistory?.data?.map((transaction) => (
                            <tr key={transaction.id}>
                              <td>{formatDateTime(transaction.createdAt)}</td>
                              <td>{transaction?.description}</td>
                              <td>{transaction?.transaction_type}</td>
                              <td>{transaction?.amount}</td>
                              <td>{transaction?.transaction_id}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {/* old static codde  */}
                      {/* <table className="transaction_table">
                        <thead>
                          <tr>
                            {" "}
                            <th>Transaction</th> <th>Type</th>
                            <th>Amount</th> <th>Date</th> <th>Status</th>
                          </tr>
                        </thead>

                        <tbody className="table-body-wrapper">
                          <tr>
                            <td>Added via UPI</td>

                            <td className="gren-text">Added</td>

                            <td className="gren-text">+ ₹500</td>

                            <td>12 Apr 2026</td>

                            <td>Success</td>
                          </tr>{" "}
                        </tbody>
                      </table> */}
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>

      {/* ADD MONEY MODAL */}
      {/* <Add_Money_Modal
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
      /> */}

      {/* WITHDRAW MODAL */}
      {/* <Withdrow_Modal
        currentBalance={parseFloat(
          allWalletHistory?.user_wallet?.amount || 0,
        ).toFixed(2)}
        show={showWithdrawModal}
        onHide={() => setShowWithdrawModal(false)}
      /> */}

      <Success_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        successText={modalData.title}
        subText={modalData.subText}
      />

      {/* <Success_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        successText="Amount Withdraw successfully!"
        subText="Your money will be credited within 24 hours."
        // handleAccept={handleAccept}
      /> */}
    </>
  );
}

export default Wallet;
